// search.js — StateDecal
// SearchOverlay Web Component: predictive search via Shopify Storefront API

class SearchOverlay extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('#search-input');
    this.results = this.querySelector('.search-overlay__results');
    this.debounceTimer = null;

    // Close on backdrop / close-button click
    this.addEventListener('click', function (e) {
      if (e.target.closest('[data-search-close]') || e.target === this) {
        this.close();
      }
    }.bind(this));

    // Close on Escape
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && this.getAttribute('aria-hidden') === 'false') {
        this.close();
      }
    }.bind(this));

    // Wire the search button(s) in the header
    document.querySelectorAll('[data-search-open]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        this.open();
      }.bind(this));
    }.bind(this));

    // Predictive search on keystroke
    if (this.input) {
      this.input.addEventListener('input', function () {
        clearTimeout(this.debounceTimer);
        this.debounceTimer = setTimeout(function () {
          this.fetchResults(this.input.value);
        }.bind(this), 280);
      }.bind(this));
    }
  }

  open() {
    this.setAttribute('aria-hidden', 'false');
    document.body.classList.add('search-open');
    if (this.input) {
      setTimeout(function () { this.input.focus(); }.bind(this), 50);
    }
  }

  close() {
    this.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('search-open');
    // Return focus to the trigger
    var trigger = document.querySelector('[data-search-open]');
    if (trigger) trigger.focus();
  }

  fetchResults(query) {
    query = (query || '').trim();
    if (query.length < 2) {
      this.results.innerHTML = '';
      return;
    }

    var url = '/search/suggest.json?q=' + encodeURIComponent(query)
            + '&resources[type]=product&resources[limit]=6';

    fetch(url)
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var products = (data.resources && data.resources.results && data.resources.results.products) || [];
        this.renderResults(products, query);
      }.bind(this))
      .catch(function () { this.results.innerHTML = ''; }.bind(this));
  }

  renderResults(products, query) {
    if (!products.length) {
      this.results.innerHTML = '<p class="search-overlay__no-results">No results for &ldquo;'
        + this.escapeHtml(query) + '&rdquo; &mdash; try a different search.</p>';
      return;
    }

    var html = '<ul class="search-overlay__list" role="listbox">';
    products.forEach(function (p) {
      var imgHtml = (p.featured_image && p.featured_image.url)
        ? '<img src="' + p.featured_image.url + '" alt="" width="56" height="56" loading="lazy" class="search-overlay__result-img">'
        : '<div class="search-overlay__result-img search-overlay__result-img--empty"></div>';

      html += '<li role="option">'
            + '<a href="' + p.url + '" class="search-overlay__result" data-search-close>'
            + imgHtml
            + '<div class="search-overlay__result-info">'
            + '<span class="search-overlay__result-title">' + this.escapeHtml(p.title) + '</span>'
            + '</div>'
            + '</a>'
            + '</li>';
    }.bind(this));
    html += '</ul>';
    html += '<div class="search-overlay__footer">'
          + '<a href="/search?q=' + encodeURIComponent(query) + '" class="search-overlay__view-all" data-search-close>'
          + 'View all results for &ldquo;' + this.escapeHtml(query) + '&rdquo; &rarr;'
          + '</a></div>';

    this.results.innerHTML = html;
  }

  escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }
}

customElements.define('search-overlay', SearchOverlay);
